import DateFnsUtils from '@date-io/date-fns';
import { Button, ButtonGroup, Grid, Paper, TextField } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import ListableCard from "../../../components/listable-card/ListableCard";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import CustomizedSnackbars from "../../../components/snackbar/Snackbar";
import TitledCard from "../../../components/titled-card/TitledCard";
import { ContentPickerModal } from "../../../containers/content-picker-modal/ContentPickerModal";
import { TargetGroupPickerModal } from "../../../containers/target-group-picker-modal/TargetGroupPickerModal";
import { createCampaign, resetLocalCampaign, updateLocalCampaign } from "../../../state/actions/CampaignActions";
import { getContentType } from "../../../state/constants/ContentType";
import styles from "./CampaignsPage.module.scss";
import { withTranslation } from 'react-i18next';


class CampaignsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            campaign: props.currentCampaign,

            selectedTargetGroups: [],
            selectedTargetContent: [],

            modelTypeData: ["Customers", "Products"],
            targetGroupModalOpen: false,
            snackbarOpen: false,
            targetGroupsLoading: false,
            targetContentModalOpen: false,
            targetContentLoading: false
        }
    }

    componentDidUpdate() {
        if (
            JSON.stringify(this.state.campaign) !==
            JSON.stringify(this.props.currentCampaign)
        ) {
            this.setState({
                campaign: this.props.currentCampaign,
            });
        }
    }

    componentWillUnmount() {
        this.props.resetLocalCampaign(() => { })
    }

    getTargetGroupsForIds(itemIds) {
        if (itemIds !== undefined) {
            return itemIds.map(itemId => {
                var item = {};
                this.state.modelTypeData.forEach(modelType => {
                    if (this.props.targetGroups[modelType] !== undefined) {
                        const targetGroup = this.props.targetGroups[modelType][itemId];

                        if (targetGroup !== undefined) {
                            item = { id: targetGroup.id, secondaryText: modelType, Name: targetGroup.DisplayName };
                        }
                    }
                });
                return item;
            });
        }

        return [];
    }

    handleTargetGroupSelection(selectedItems) {
        const selectedTargetGroups = this.getTargetGroupsForIds(selectedItems);

        var campaign = Object.assign({}, this.state.campaign);

        selectedTargetGroups.forEach(group => {
            campaign.TargetGroups.push(group.id);
        });

        // campaign.TargetGroups = selectedTargetGroups.map(targetGroup => targetGroup.id)
        this.props.updateLocalCampaign(campaign, () => {
            this.setState({
                campaign: this.props.currentCampaign,
                selectedTargetGroups: selectedTargetGroups,
                targetGroupModalOpen: false
            });
        });
    }

    handleTargetGroupDeletion(selectedItems) {
        var campaign = Object.assign({}, this.state.campaign);
        campaign.TargetGroups = campaign.TargetGroups.filter(targetGroup => !selectedItems.includes(targetGroup));
        const selectedTargetGroups = this.state.selectedTargetGroups.filter(targetGroup => !selectedItems.includes(targetGroup.id));
        this.props.updateLocalCampaign(campaign, () => {
            this.setState({
                campaign: this.props.currentCampaign,
                selectedTargetGroups: selectedTargetGroups
            });
        });
    }

    getTargetContentForIds(itemIds) {
        const ContentType = getContentType()
        if (itemIds !== undefined) {
            return itemIds.map(itemId => {                
                const targetContent = this.props.files[itemId];
                const mustSellContent = this.props.mustSells[itemId];
                const productGroups = this.props.groups[itemId];
                const forms = this.props.forms[itemId];
                const objectives = this.props.objectives[itemId];
                const customerFlags = this.props.customerFlags[itemId];
                const priceLists = this.props.priceLists[itemId];
                const dashboardLayouts = this.props.dashboardLayouts[itemId]

                if (targetContent !== undefined) {
                    return { id: targetContent.id, type: targetContent.Type, secondaryText: ContentType.File.value, Name: targetContent.DisplayName };
                }

                if (mustSellContent !== undefined) {
                    return { id: mustSellContent.id, type: ContentType.MustSell.key, secondaryText: ContentType.MustSell.value, Name: mustSellContent.Name };
                }

                if (productGroups !== undefined) {
                    return { id: productGroups.id, type: ContentType.ProductGroup.key, secondaryText: ContentType.ProductGroup.value, Name: productGroups.Name };
                }

                if (forms !== undefined) {
                    return { id: forms.id, type: ContentType.Forms.key, secondaryText: ContentType.Forms.value, Name: forms.Name };
                }

                if (objectives !== undefined) {
                    return { id: objectives.id, type: ContentType.Objectives.key, secondaryText: ContentType.Objectives.value, Name: objectives.Title };
                }

                if (customerFlags !== undefined) {
                    return { id: customerFlags.id, type: ContentType.CustomerFlag.key, secondaryText: ContentType.CustomerFlag.value, Name: customerFlags.Name };
                }

                if (priceLists !== undefined) {
                    return { id: priceLists.id, type: ContentType.PriceLists.key, secondaryText: ContentType.PriceLists.value, Name: priceLists.Name };
                }

                if (dashboardLayouts !== undefined) {
                    return { id: dashboardLayouts.id, type: ContentType.DashboardLayouts.key, secondaryText: ContentType.DashboardLayouts.value, Name: dashboardLayouts.id };
                }

                return { id: itemId, Name: this.props.t('campaign.unknown-deleted-content'), notClickable: true };
            });
        }

        return [];
    }

    handleTargetContentSelection(selectedItems) {
        const selectedTargetContent = this.getTargetContentForIds(selectedItems);
        var campaign = Object.assign({}, this.state.campaign);

        selectedTargetContent.forEach(content => {
            campaign.TargetContent.push({ Type: content.type, Id: content.id, DisplayName: content.Name });
        });
        this.props.updateLocalCampaign(campaign, () => {
            this.setState({
                campaign: this.props.currentCampaign,
                selectedTargetContent: selectedTargetContent,
                targetContentModalOpen: false
            });
        });
    }

    handleTargetContentDeletion(selectedItems) {
        var campaign = Object.assign({}, this.state.campaign);
        campaign.TargetContent = campaign.TargetContent.filter(targetContent => !selectedItems.includes(targetContent.Id));
        const selectedTargetContent = this.state.selectedTargetContent.filter(targetContent => !selectedItems.includes(targetContent.id));

        this.props.updateLocalCampaign(campaign, () => {
            this.setState({
                campaign: this.props.currentCampaign,
                selectedTargetContent: selectedTargetContent
            });
        });
    }

    renderData() {
        return (
            <div className={styles.contentGrid}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Paper>
                            <TitledCard
                                title={this.props.t('hierarchy.display-name')}>
                                <TextField
                                    classes={{ root: styles.textField }}
                                    label={this.props.t('hierarchy.display-name')}
                                    value={this.props.currentCampaign.DisplayName}
                                    onChange={(event) => {
                                        var campaign = Object.assign({}, this.state.campaign);
                                        campaign.DisplayName = event.target.value
                                        this.props.updateLocalCampaign(campaign, () => {
                                            this.setState({ campaign: this.props.currentCampaign });
                                        });
                                    }}
                                    variant="outlined"
                                    margin="dense"
                                />
                            </TitledCard>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            <TitledCard
                                title={this.props.t('hierarchy.start-date')}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="dense"
                                        classes={{ root: styles.datePicker }}
                                        disableToolbar
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/yyyy"
                                        label={this.props.t('campaign.select-start-date')}
                                        value={this.state.campaign.StartDate}
                                        onChange={(date) => {
                                            var campaign = Object.assign({}, this.state.campaign);
                                            campaign.StartDate = date
                                            this.props.updateLocalCampaign(campaign, () => {
                                                this.setState({ campaign: this.props.currentCampaign });
                                            });
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </TitledCard>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            <TitledCard
                                title={this.props.t('hierarchy.end-date')}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="dense"
                                        classes={{ root: styles.datePicker }}
                                        disableToolbar
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/yyyy"
                                        label={this.props.t('campaign.select-end-date')}
                                        value={this.state.campaign.EndDate}
                                        onChange={(date) => {
                                            var campaign = Object.assign({}, this.state.campaign);
                                            campaign.EndDate = date
                                            this.props.updateLocalCampaign(campaign, () => {
                                                this.setState({ campaign: this.props.currentCampaign });
                                            });
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </TitledCard>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            <ListableCard
                                actionButton={[
                                    <Button
                                        onClick={() => this.setState({ targetGroupModalOpen: true })}
                                        variant="outlined"
                                        color="secondary"
                                    >
                                        {this.props.t('target-group.select')}
                                  </Button>
                                ]}
                                addLabel={"Add Target Group"}
                                isLoading={this.state.targetGroupsLoading}
                                title={this.props.t('target-group.target-groups')}
                                emptyPlaceholder={this.props.t('campaign.none-added')}
                                handleDelete={(data) => this.handleTargetGroupDeletion(data)}
                                onClick={id => {

                                }}
                                data={this.state.campaign.TargetGroups == null ? [] : this.getTargetGroupsForIds(this.state.campaign.TargetGroups)}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            <ListableCard
                                actionButton={[
                                    <Button
                                        onClick={() => this.setState({ targetContentModalOpen: true })}
                                        variant="outlined"
                                        color="secondary"
                                    >
                                        {this.props.t('campaign.select')}
                                    </Button>
                                ]}
                                addLabel={this.props.t('campaign.add-content')}
                                isLoading={this.state.targetContentLoading}
                                title={this.props.t('campaign.target-content')}
                                emptyPlaceholder={this.props.t('campaign.no-content')}
                                handleDelete={(data) => this.handleTargetContentDeletion(data)}
                                data={this.state.campaign.TargetContent == null ? [] : this.getTargetContentForIds(this.state.campaign.TargetContent.map(content => content.Id))}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }

    render() {

        if (this.state.loadingCategory) {
            return <Loading />
        }

        return (
            <div>
                <HeaderBlock
                    title={
                        this.props.t('campaign.campaigns')
                    }
                    right={
                        <Grid container spacing={2} alignItems="center" justify="flex-end">
                            <Grid item>
                                <ButtonGroup>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => {
                                            this.props.createCampaign(this.state.campaign, (success) => {
                                                if (success) {
                                                    this.props.history.push("/campaigns");
                                                }
                                            })
                                        }}
                                    >
                                        {this.props.t('common.submit')}
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    }
                />
                <CustomizedSnackbars handleClose={() => { this.setState({ snackbarOpen: false }) }} open={this.state.snackbarOpen} variant="error" message={"Please select a Model Type before adding Target Groups"} />

                <TargetGroupPickerModal
                    handleCancel={() => {
                        this.setState({ targetGroupModalOpen: false });
                    }}
                    handleDone={selectedItems => {
                        this.handleTargetGroupSelection(selectedItems);
                    }}
                    open={this.state.targetGroupModalOpen}
                    selected={this.state.campaign.TargetGroups}
                />

                <ContentPickerModal
                    handleCancel={() => {
                        this.setState({ targetContentModalOpen: false });
                    }}
                    handleDone={selectedItems => {
                        this.handleTargetContentSelection(selectedItems);
                    }}
                    open={this.state.targetContentModalOpen}
                    cols={2}
                    spacing={8}
                    cellHeight={90}
                    selected={this.state.campaign.TargetContent.map(content => content.Id)}
                />
                <PageContainer>
                    {this.renderData()}
                </PageContainer>
            </div>
        );
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { targetGroups } = state.TargetGroupReducer
    const { files } = state.FileDownloadReducer
    const { currentCampaign } = state.CampaignReducer
    const { mustSells } = state.MustSellReducer
    const { groups } = state.GroupReducer
    const { forms } = state.FormsReducer
    const { objectives } = state.ObjectivesReducer
    const { customerFlags } = state.CustomerFlagReducer
    const { priceLists } = state.PriceListsReducer
    const { dashboardLayouts } = state.DashboardLayoutReducer

    return {
        targetGroups,
        files,
        currentCampaign,
        mustSells,
        groups,
        forms,
        objectives,
        customerFlags,
        priceLists,
        dashboardLayouts
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            createCampaign,
            updateLocalCampaign,
            resetLocalCampaign
        },
        dispatch
    );

const hoc = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withTranslation()(CampaignsPage))
);

// EXPORT COMPONENT

export { hoc as CampaignsPage };

